import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/CaseNoteEditPageQuery$parameters.ts';
import type { CaseNoteEditPageQuery as CaseNoteEditPageQueryType } from './__generated__/CaseNoteEditPageQuery.graphql.ts';

type Queries = {
	caseNote: CaseNoteEditPageQueryType;
};

type CaseNoteEditEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const caseNoteEditEntryPoint: EntryPoint<
	CaseNoteEditEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CaseNoteEditEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-case-note-edit" */ './CaseNoteEditPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			caseNote: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey ?? '',
				},
			},
		},
		entryPoints: {},
		extraProps: {},
	}),
});
